import React, { useEffect, useState } from "react";
import "./index.css";
import { Typography, Grid, Box, Autocomplete, TextField } from "@mui/material";
import { useAppSelector } from "../../stores/store";
import { Device } from "../../types";
import HeadLine from "../HeadLine";

const DeviceInfo = () => {
  const devices = useAppSelector((state) => state?.devices?.devices);
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);

  useEffect(() => {
    if (devices.length > 0) {
      setSelectedDevice(devices[0]);
    }
  }, [devices]);

  return (
    <Box className="container-device-info">
      <HeadLine value="Device Info" />

      <Grid container className="box-device-info" rowSpacing={2}>
        <Grid size={12}>
          <Autocomplete
            className="select-device"
            fullWidth={true}
            disablePortal
            options={devices}
            value={selectedDevice}
            getOptionLabel={(cur) => cur.displayName || ""}
            getOptionKey={(cur) => cur.id || ""}
            renderInput={(params) => <TextField {...params} label="Devices" />}
            onChange={(_: React.SyntheticEvent, value: Device | null) => {
              setSelectedDevice(value);
            }}
          />
        </Grid>
        <Grid size={4}>
          <Typography>Display Name:</Typography>
        </Grid>
        <Grid size={6}>
          <Typography align={"center"}>
            {selectedDevice?.displayName}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography>Algorithm Version:</Typography>
        </Grid>
        <Grid size={6}>
          <Typography align={"center"}>
            {selectedDevice?.algorithmVersion}
          </Typography>
        </Grid>

        <Grid size={4}>
          <Typography>Firmware Version:</Typography>
        </Grid>
        <Grid size={6}>
          <Typography align={"center"}>
            {selectedDevice?.firmwareVersion}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DeviceInfo;
